module.exports = __webpack_public_path__ + "img/banner_left.fcd502f9.jpg";